import styled, { css } from 'styled-components';

export const ProductListSectionWrapper = styled.section`
  padding: 60px 0;
  background-color: #f9f9f9;
  @media (max-width: 1200px) {
    padding: 60px 0;
  }
  @media (max-width: 990px) {
    padding: 50px 0;
  }
  @media (max-width: 767px) {
    padding: 30px 0;
  }
  @media (max-width: 575px) {
    padding: 30px 0;
  }

  .row {
    display: flex;
    ${'' /* @media (max-width: 1200px) {
      display: flex;
    }
    @media (max-width: 990px) {
      display: flex;
    } */}
    @media (max-width: 767px) {
      display: inherit;
    }
    ${'' /* @media (max-width: 575px) {
      display: inherit;
    } */}

    .product_list {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
      grid-gap: 10px;
    }

    .col {
      &.product_list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        grid-gap: 10px;
      }
    }
    .no_items {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: white;
      border-radius: 10px;
      color: ${({ theme }) => theme.colors.labelColor};
      font-weight: 500;
    }
  }
`;

export const ProductItem = styled.div`
  padding: 50px 30px;
  background: #fff;
  border-radius: 10px;
  @media (max-width: 1200px) {
    padding: 40px 20px;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export const SideBarStyle = styled.div`
  padding: 50px 30px;
  margin-right: 15px;
  background: #fff;
  border-radius: 10px;
  @media (max-width: 1200px) {
    padding: 40px 20px;
  }
  @media (max-width: 767px) {
    margin-right: 0;
    margin-bottom: 15px;
  }
  .container:nth-child(2) {
    padding-top: 30px;
  }
`;

export const List = styled.ul``;

export const ListItem = styled.li`
  a {
    ${'' /* color: #fff;
    font-size: 14px;
    line-height: 36px; */}
    color: ${({ theme }) => theme.colors.labelColor};
    transition: all 0.2s ease;
    &:hover,
    &:focus {
      outline: 0;
      text-decoration: none;
      opacity: 0.75;
    }
  }
  ${props =>
    props.active &&
    css`
      border-left: 3px solid ${props.theme.colors.link};
      a {
        margin-left: 5px;
        color: ${props.theme.colors.link};
      }
    `}
`;

export const ProductImageWrapper = styled.div`
  min-height: 97px;
`;

export const PrevButton = styled.div`
  position: relative;
  padding: 18px 10px;
  cursor: pointer;
  &:hover {
    span {
      background: ${({ theme }) => theme.colors.primary};
      @media (min-width: 991px) {
        width: 100px;
      }
    }
  }
  span {
    width: 18px;
    height: 2px;
    background: #d1d3de;
    display: block;
    position: relative;
    transition: 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    &:before,
    &:after {
      content: '';
      display: block;
      height: 2px;
      border-radius: 2px;
      background: inherit;
      position: absolute;
    }
    &:before {
      transform: rotate(-45deg);
      top: -4px;
      left: 0;
      width: 10px;
    }
    &:after {
      transform: rotate(45deg);
      width: 8px;
      bottom: -6px;
      left: 1px;
    }
  }
`;

export const NextButton = styled.div`
  position: relative;
  padding: 18px 10px;
  cursor: pointer;
  &:hover {
    span {
      background: ${({ theme }) => theme.colors.primary};
      @media (min-width: 991px) {
        width: 100px;
      }
    }
  }
  span {
    width: 18px;
    height: 2px;
    background: #d1d3de;
    display: block;
    position: relative;
    transition: 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    &:before,
    &:after {
      content: '';
      display: block;
      height: 2px;
      border-radius: 2px;
      background: inherit;
      position: absolute;
    }
    &:before {
      transform: rotate(45deg);
      top: -4px;
      right: 0;
      width: 10px;
    }
    &:after {
      transform: rotate(-45deg);
      width: 8px;
      bottom: -6px;
      right: 1px;
    }
  }
`;
